import { render } from "./CourseShortCardTooltip.vue?vue&type=template&id=65b24306&scoped=true"
import script from "./CourseShortCardTooltip.vue?vue&type=script&lang=js"
export * from "./CourseShortCardTooltip.vue?vue&type=script&lang=js"

import "./CourseShortCardTooltip.vue?vue&type=style&index=0&id=65b24306&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65b24306"]])

export default __exports__